const academicMembersWrapper = document.getElementById('academic-members__wrapper');
if (academicMembersWrapper) {
  const viewContentElement = academicMembersWrapper.querySelector('.view-content');
  if (viewContentElement) {
    viewContentElement.classList.add('cems-slider', 'cems-slider--arrows', 'cems-slide--academic-members', 'cems-slider--auto-play');
    viewContentElement.setAttribute('id', 'academic-members-slider');
  }
} else {
  console.warn('Element academic-members__wrapper non trouvé');
}


(function ($) {
  DJ.addBehavior('cemsSlider', '.cems-slider', {
    attach: function () {
      const sliderElement = this;
      const $slider = $(sliderElement);
      const sliderId = $slider.attr('id');
      const sliderTimer = sliderElement.getAttribute('data-slider-timer') || 5000;
      const isSliderWithArrows = $slider.hasClass('cems-slider--arrows');
      const isSliderWithCustomArrows = $slider.hasClass('cems-slider--customArrows');
      const isSliderWithCenterMode = $slider.hasClass('cems-slider--center-mode');
      const isSliderAutoPlay = $slider.hasClass('cems-slider--auto-play');
      const isSliderDesktop = $slider.hasClass('cems-slider--desktop');
      const isSliderTablet = $slider.hasClass('cems-slider--tablet');
      const isSliderPartners = $slider.hasClass('cems-slide--partners');
      const isSliderKeyFigures = $slider.hasClass('cems-slide--key-figures');
      const isSliderInterviews = $slider.hasClass('cems-slide--interviews');
      const isSliderEvents = $slider.hasClass('cems-slide--events');
      const isSliderAcademicMembers = $slider.hasClass('cems-slide--academic-members');
      const interviewsItemCount = isSliderInterviews ? $('.cems-slide--interviews > div').length : null;
      const svgPath = DJ.getDrupalSettings().isSlicingEnvironment
        ? '../../assets/sprites/symbol/svg/sprite.symbol.svg'
        : '/themes/custom/cems_front/public/assets/sprites/symbol/svg/sprite.symbol.svg';
      let currentBreakpoint = DJ.bp.name;

      const updateSliderCounter = (slick, currentSlide) => {
        const current = (currentSlide !== undefined ? currentSlide : 0) + 1;
        const totalSlides = slick.slideCount;
        $(`.pagingInfo-${sliderId}`).text(`${current}/${totalSlides}`);
      };

      const getSlidesToShow = (device) => {
        if (device === 'default') {
          if (isSliderPartners) return 7;
          if (isSliderEvents) return 3;
          if (isSliderAcademicMembers) return 4;
        }

        if (device === '1025') {
          if (isSliderPartners || isSliderEvents || isSliderAcademicMembers) return 3;
        }

        if (device === '768') {
          if (isSliderAcademicMembers) return 3;
        }
        return 1;
      };

      const getCenterPadding = (device) => {
        if (device === '1025') {
          if (isSliderEvents) return '10px';
        }

        if (device === '768') {
          if (isSliderKeyFigures) return '25%';
          if (isSliderEvents) return '15%';
        }

        if (device === '546') {
          if (isSliderKeyFigures) return '25%';
          if (isSliderEvents) return '8%';
        }

        if (device === '360') {
          if (isSliderKeyFigures) return '20%';
          if (isSliderEvents) return '8%';
        }
        return '0';
      };

      const getSlidesToScroll = (device) => {
        if (device === 'default') {
          if (isSliderPartners) return 5;
          if (isSliderAcademicMembers) return 4;
        }

        if (device === '1025') {
          if (isSliderPartners || isSliderAcademicMembers) return 3;
        }

        if (device === '768') {
          if (isSliderAcademicMembers) return 3;
        }
        return 1;
      };

      const buildSlider = (sliderToBuild) => {
        if (!sliderToBuild[0].getAttribute('data-slider-init')) {
          
          let sliderItemCount = sliderToBuild.children().length;

          //condition pour CP si c'est pas modulo 3, clonage d'un CP du milieu d'objet jusqu'a modulo 3
          if (isSliderPartners) {
            let childrenArray = sliderToBuild.children().toArray();
          
            let middleIndex1 = Math.floor((childrenArray.length - 1) / 2);
            let middleIndex2 = middleIndex1 + 1;
            let middleValue1 = childrenArray[middleIndex1];
            let middleValue2 = childrenArray[middleIndex2];
          
            let resultModulo = childrenArray.length % 3;
            let valuesToAdd = (resultModulo === 0) ? 0 : 3 - resultModulo;
          
            for (let i = 0; i < valuesToAdd; i++) {
              if (i % 2 === 0) {
                childrenArray.push($(middleValue1).clone()[0]);
              } else {
                childrenArray.push($(middleValue2).clone()[0]);
              }
            }
            sliderToBuild.empty().append(childrenArray);
          }

            //paremetre par defaut avant modification du 14/11/24
            let infiniteSetting = true;
            let slidesToShowSetting = getSlidesToShow('default');
            let slidesToScrollSetting = getSlidesToScroll('default');
            let centerModeSetting = isSliderWithCenterMode
            let dotsSetting = !(isSliderWithArrows || isSliderWithCustomArrows || isSliderPartners);
            let arrowsSetting = (isSliderWithArrows || isSliderWithCustomArrows)
            //fin parametre par defaut 
            
            if(isSliderEvents && sliderItemCount < 4 && !(DJ.bp.name === 'tablet' || DJ.bp.name === 'mobile')){
              infiniteSetting = false;
              slidesToShowSetting = sliderItemCount;
              slidesToScrollSetting = 1;
              centerModeSetting = true;
              dotsSetting = true;
              arrowsSetting = false;
            }

          sliderToBuild.on('init', function (event, slick) {
            updateSliderCounter(slick, 0);
            if (sliderItemCount < 4 && isSliderEvents && sliderToBuild.hasClass('isDesktop')) { 
              sliderToBuild.find('.slick-slide').addClass('slick-center slick-active'); 
            }
          }).on('afterChange', function (event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
            if (sliderItemCount < 4 && isSliderEvents && sliderToBuild.hasClass('isDesktop')) { 
              sliderToBuild.find('.slick-slide').addClass('slick-center slick-active'); 
            }
          });

          sliderToBuild.slick({
            infinite: infiniteSetting,
            rows: isSliderPartners ? 3 : 1,
            variableWidth: isSliderPartners,
            slidesToShow: slidesToShowSetting,
            slidesToScroll: slidesToScrollSetting,
            dots: dotsSetting,
            centerMode: centerModeSetting,
            arrows: arrowsSetting,
            prevArrow: isSliderWithCustomArrows ? $(`.prev-${sliderId}`) : `<button type="button" class="slick-prev">
                        <span class="svg-icon"><svg><use xlink:href="${svgPath}#arrow"></use></svg></span>
                      </button>`,
            nextArrow: isSliderWithCustomArrows ? $(`.next-${sliderId}`) : `<button type="button" class="slick-next">
                        <span class="svg-icon"><svg><use xlink:href="${svgPath}#arrow"></use></svg></span>
                      </button>`,
            autoplay: isSliderAutoPlay,
            autoplaySpeed: sliderTimer,
            pauseOnHover: true,
            pauseOnFocus: true,
            pauseOnDotsHover: true,
            useCSS: false,
            responsive: [
              {
                breakpoint: 1025,
                settings: {
                  infinite: sliderItemCount > 3,
                  slidesToShow: getSlidesToShow('1025'),
                  slidesToScroll: getSlidesToScroll('1025'),
                  centerPadding: getCenterPadding('1025')
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: getSlidesToShow('768'),
                  slidesToScroll: getSlidesToScroll('768'),
                  centerPadding: getCenterPadding('768'),
                }
              },
              {
                breakpoint: 546,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerPadding: getCenterPadding('546'),
                }
              },
              {
                breakpoint: 360,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerPadding: getCenterPadding('360'),
                }
              },
            ]
          });

          sliderToBuild[0].setAttribute('data-slider-init', 'true');
        }
      };

      const destroySlider = (sliderToDestroy) => {
        if (sliderToDestroy[0].getAttribute('data-slider-init')) {
          sliderToDestroy.slick('unslick');
          sliderToDestroy[0].removeAttribute('data-slider-init');
        }
      };

      const checkSlider = () => {
        if (DJ.bp.name === 'tablet' || DJ.bp.name === 'mobile') {
          destroySlider($('.cems-slider--desktop'));
          buildSlider($('.cems-slider--tablet'));
        } else {
          destroySlider($('.cems-slider--tablet'));
          buildSlider($('.cems-slider--desktop'));
        }
      };

      const checkInterviews = (itemCount) => {
        if (DJ.bp.name === 'tablet' || DJ.bp.name === 'mobile' || itemCount > 2) {
          buildSlider($('.cems-slide--interviews'));
        } else {
          destroySlider($('.cems-slide--interviews'));
          $('.cems-slide--interviews').addClass('less-than-two');
        }
      };

      $(window).resize(function () {
        clearTimeout(window.resizedFinished);

        window.resizedFinished = setTimeout(function () {
          if (currentBreakpoint !== DJ.bp.name) {
            if (isSliderDesktop || isSliderTablet) {
              checkSlider();
            }
            if (isSliderInterviews) {
              checkInterviews(interviewsItemCount);
            }
            currentBreakpoint = DJ.bp.name;
          }
        }, 500);
      });

      if (isSliderDesktop || isSliderTablet) {
        checkSlider();
      } else if (isSliderInterviews) {
        checkInterviews(interviewsItemCount);
      } else {
        buildSlider($slider);
      }
    }
  });
})(jQuery);
